/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Company } from '../models/Company';
import type { CompanyAiPoweredJobRecommendationsRequest } from '../models/CompanyAiPoweredJobRecommendationsRequest';
import type { CompanyIsAutoApplySpreadRequest } from '../models/CompanyIsAutoApplySpreadRequest';
import type { CompanyIsAutoPricingRequest } from '../models/CompanyIsAutoPricingRequest';
import type { CompanyJobMappingModeRequest } from '../models/CompanyJobMappingModeRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyService {

    /**
     * Get user company
     * @returns any Success
     * @throws ApiError
     */
    public static getUserCompany({
        includeQuickSight,
    }: {
        includeQuickSight?: boolean,
    }): CancelablePromise<{
        company: Company;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/company',
            query: {
                'includeQuickSight': includeQuickSight,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update user company settings
     * @returns Company Success
     * @throws ApiError
     */
    public static updateUserCompanySettings({
        requestBody,
    }: {
        requestBody: (CompanyIsAutoPricingRequest | CompanyJobMappingModeRequest | CompanyIsAutoApplySpreadRequest | CompanyAiPoweredJobRecommendationsRequest),
    }): CancelablePromise<Company> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Get companies list
     * @returns any Success
     * @throws ApiError
     */
    public static getCompaniesList({
        isAllowCsAccess,
    }: {
        isAllowCsAccess?: boolean,
    }): CancelablePromise<Array<{
        id?: number;
        name?: string;
    }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/company/list',
            query: {
                'isAllowCSAccess': isAllowCsAccess,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
